import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <h1>
          Your Airtable <span style={{ color: '#2563eb' }}>Thinks For You</span>
        </h1>
        <p className="subheading">
          Query answers. Predict futures. Explain changes. Simulate outcomes. Detect anomalies. Prove decisions. Take action. All with causal intelligence.
        </p>
      </div>
    </section>
  );
};

export default Hero;
